var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/navigation/Link.tsx";
import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import LinkBase from './LinkBase';
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Styled component for a link (`<a>` element).
 */
const LinkNext = function Link({
  children,
  classes,
  elementRef,
  underline = 'none',
  color = 'brand',
  ...htmlAttributes
}) {
  return _jsxDEV(LinkBase, {
    "data-component": "Link",
    ...htmlAttributes,
    classes: classnames('rounded-sm',
    // NB: Base classes are applied by LinkBase
    {
      // color
      'text-brand hover:text-brand-dark': color === 'brand',
      // default
      'text-color-text-light hover:text-brand': color === 'text-light',
      'text-color-text hover:text-brand-dark': color === 'text'
    }, {
      // underline
      'no-underline hover:no-underline': underline === 'none',
      // default
      'underline hover:underline': underline === 'always',
      'no-underline hover:underline': underline === 'hover'
    }, classes),
    elementRef: downcastRef(elementRef),
    children: children
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 31,
    columnNumber: 5
  }, this);
};
export default LinkNext;
//# sourceMappingURL=Link.js.map